export default __webpack_public_path__ + "static/media/call-to-action.4bf9c170.svg";